import { render, staticRenderFns } from "./ShortLinksWidget.vue?vue&type=template&id=55379292&scoped=true&"
import script from "./ShortLinksWidget.vue?vue&type=script&lang=js&"
export * from "./ShortLinksWidget.vue?vue&type=script&lang=js&"
import style0 from "./ShortLinksWidget.vue?vue&type=style&index=0&id=55379292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55379292",
  null
  
)

export default component.exports